import React from "react";
import { Button, DialogActions, Flex, IconName, Modal, Text } from "@theorgchartdev/storybook";
import CentralizedModalContainer from "@/appComponents/Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import { appstr } from "@coreapp/utils/appstr";
import { useGuideStep } from "./GuideStepContext";

export interface GuideModalProps {
  children: React.ReactNode;
  completeLabel?: string;
  completeIcon?: IconName;
  dismissLabel?: string;
}

const GuideModal: React.FC<GuideModalProps> = ({
  children,
  completeLabel,
  completeIcon,
  dismissLabel
}) => {
  const { guideId, stepIndex, onComplete, onDismiss, onNext, onPrev, stepIndicator, isLast } =
    useGuideStep();

  return (
    <CentralizedModalContainer show={true}>
      <Modal
        id="native-guide-modal"
        data-testid={`native-guide-${guideId}-modal`}
        centerScreen
        maxWidth="small"
        minWidth="xsmall"
        onClose={onDismiss}
        show={true}
        hideOverlay
        withShadow
      >
        {children}
        <DialogActions>
          <Flex alignItems="center" gap="8px" style={{ marginRight: "auto" }}>
            {onPrev && (
              <Button modifier="secondary" onClick={onPrev}>
                {appstr("Back")}
              </Button>
            )}
            {stepIndicator && <Text colorModifier="grey">{stepIndicator}</Text>}
          </Flex>

          <DialogActions.Tertiary
            onClick={onDismiss}
            dataTestId={`native-guide-${guideId}-modal-step-${stepIndex}-dismiss`}
          >
            {dismissLabel ?? appstr("Dismiss")}
          </DialogActions.Tertiary>
          <DialogActions.Primary
            onClick={isLast ? onComplete : onNext}
            iconProps={completeIcon ? { name: completeIcon } : undefined}
            iconAlignEnd
            dataTestId={`native-guide-${guideId}-modal-step-${stepIndex}-primary`}
          >
            {isLast ? (completeLabel ?? appstr("Got it")) : appstr("Next")}
          </DialogActions.Primary>
        </DialogActions>
      </Modal>
    </CentralizedModalContainer>
  );
};

export default GuideModal;
